import BackOrderProducts from './BackOrderProducts/backOrderProductsReport';
import CustomerOrderCount from './CustomerOrderCount';
import DormantCustomers from './DormantCustomers';

export default {
  BackOrderProducts: BackOrderProducts,
  CustomerOrderCount: CustomerOrderCount,
  DormantCustomers: DormantCustomers
};
